export let doctorLevels = [
  {
    label: '医师',
    value: 'PHYSICIAN'
  },
  {
    label: '主治医师',
    value: 'ATTENDING_PHYSICIAN'
  },
  {
    label: '副主任医师',
    value: 'DEPUTY_CHIEF_PHYSICIAN'
  },
  {
    label: '主任医师',
    value: 'CHIEF_PHYSICIAN'
  },

  {
    label: '护士',
    value: 'NURSE'
  },
  {
    label: '护师',
    value: 'NURSING_PHYSICIAN'
  },
  {
    label: '主管护师',
    value: 'NURSE_IN_CHARGE'
  },
  {
    label: '副主任护师',
    value: 'DEPUTY_CHIEF_NURSE'
  },
  {
    label: '主任护师',
    value: 'CHIEF_NURSE'
  }
]
